import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicesOrganismService {
  private accessToken = '';
  private apiUrl = '';

  constructor(private http: HttpClient) { }

  public getInstagramPosts(): Observable<any> {
    const url = ``;
    return this.http.get<any>(url);
  }

  public getTweets() {
    const headers = {
      Authorization: ``,
    };
    return this.http.get(this.apiUrl, { headers });
  }
}
